export default "__VITE_ASSET__c2b3a5f0__"